export default "__VITE_ASSET__Bkn$fnnz__"